import Field from './Field';
import { humanize } from '@/lib/humanize';
import { filterArtifactTypes } from '@/lib/filters';

/**
 * Renders one entry of contribution.artifacts, using the schema's own
 * property names (type_of_artifact, research_method, evaluation_method,
 * data_collection, threats_to_validity, implementation).
 */
export default function ArtifactCard({ artifact, index }) {
  const researchMethod = artifact.research_method || {};
  const dataCollection = artifact.data_collection || {};
  const participants = dataCollection.participants || {};
  const implementation = artifact.implementation || {};

  return (
    <div className="artifact-card">
      <h4 className="artifact-card__title">Artifact {index + 1}</h4>
      <Field label={humanize('type_of_artifact')} value={filterArtifactTypes(artifact.type_of_artifact || [])} />
      <Field label={humanize('research_method')} value={researchMethod.methods} />
      <Field label={humanize('other')} value={researchMethod.other} chips={false} />
      <Field label={humanize('evaluation_method')} value={artifact.evaluation_method} />
      <Field label={humanize('data_type')} value={dataCollection.data_type} />
      <Field label={humanize('total_participants')} value={participants.total_participants} />
      <Field label={humanize('students')} value={participants.students} />
      <Field label={humanize('practitioners')} value={participants.practitioners} />
      <Field label={humanize('material_accessibility')} value={dataCollection.material_accessibility} />
      <Field label={humanize('data_accessibility')} value={dataCollection.data_accessibility} />
      <Field label={humanize('threats_to_validity')} value={artifact.threats_to_validity} />
      <Field label={humanize('existence')} value={implementation.existence} />
      <Field label={humanize('availability')} value={implementation.availability} />
    </div>
  );
}
